<template>
    <main id="mainCtrl">
        <PromotionEdit ref="promotionEditDialog"/>
        <header>
            <button @click="createPromotion">
                <span>Добавить акцию</span>
            </button>
        </header>
        <v-table id="promotionsTable"
                 request-uri="promotions/getList"
                 pagesize="50"
                 :lazycount="false"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="img" width="170">
                        Картинка
                    </v-th>
                    <v-th name="name" sort="name" minwidth="200">
                        Название
                    </v-th>
                    <v-th name="description" sort="description" minwidth="200">
                        Описание
                    </v-th>
                    <v-th name="promotionsActivity" width="75">
                        Период
                    </v-th>
                    <v-th name="discount" width="75">
                        Скидка
                    </v-th>
                </v-tr>

                <v-tr>
                    <v-th name="img"></v-th>
                    <v-th name="name" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="description" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="promotionsActivity" v-slot="{filter}" width="75">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                   value: "willBegin",
                                   text: "Запланирована"
                                },
                                                        {
                                   value: "active",
                                   text: "Активна"
                                },
                                {
                                    value: "ended",
                                    text: "Закончилась"
                                },
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="discount" v-slot="{filter}" width="75">
                        <v-input v-model="filter.value"/>
                    </v-th>

                </v-tr>

            </template>

            <template v-slot:row="{ item, index, indexOnPage }">
                <v-tr :class="['hover', 'pointer', {'warning': item.moderationNeeded}]" @click="(row, event) => handleRowClick(event, row, item)">
                    <v-td name="img" height="24">
                        <img
                            v-if="item.img"
                            src=""
                            alt=""
                            class="avatar"
                            :src="item.img ? storagePublicUrl + '/images/promotions/265x149/' + item.img : ''"
                            width="160"
                            height="90"/>
                    </v-td>
                    <v-td name="name">
                        <span>{{ item.name }}</span>
                    </v-td>
                    <v-td name="description">
                        <span class="max4LinesText" v-html="item.description" />
                    </v-td>
                    <v-td name="promotionsActivity" highlight="*" width="75">
                        {{item.dateFrom | formatDatePeriodShort(item.dateTill) }}
                    </v-td>
                    <v-td name="discount" highlight="*" width="75" align="center">
                        <span>{{ item.discount? item.discount+' %': '-' }}</span>
                    </v-td>
                </v-tr>
            </template>

        </v-table>
    </main>
</template>
<script>
    import PromotionEdit from "@dialogs/PromotionEditDialog";
    import {STORAGE_PUBLIC} from "@global/const";
    export default {
        components:{
            PromotionEdit,
        },
        props: {
            city: {
                type: String,
                required: true,
            },
            url: {
                type: String,
                required: true,
            },
        },
        methods:{
            handleRowClick(event, row, item) {
                row.startLoadingAnimation();
                this.axios.get('promotions/read/' + item.id).then(response => {
                    this.$refs.promotionEditDialog.read(response.data.data, this.city, this.url)
                    row.stopLoadingAnimation()
                });
            },
            createPromotion(){
                this.$refs.promotionEditDialog.create()
            },
        },
        computed:{
            storagePublicUrl() {
                return STORAGE_PUBLIC;
            },
        }

    }
</script>
<style lang="scss">
#promotionsTable span.max4LinesText {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;

    & p{
        margin: 0;
    }
}
</style>
